(function(){
  var KEY='co_vat';
  function mode(){try{return localStorage.getItem(KEY)==='ex'?'ex':'inc';}catch(e){return 'inc';}}
  function apply(){
    var ex=mode()==='ex';
    document.documentElement.classList.toggle('co-vat-ex',ex);
    document.querySelectorAll('[data-co-ex]').forEach(function(el){
      var want=ex?el.getAttribute('data-co-ex'):el.getAttribute('data-co-inc');
      if(want&&el.textContent.trim()!==want.trim()) el.textContent=want;
    });
    document.querySelectorAll('[data-co-vat]').forEach(function(b){
      b.setAttribute('aria-pressed',((b.getAttribute('data-co-vat')==='ex')===ex)?'true':'false');
    });
  }
  document.addEventListener('click',function(e){
    var b=e.target.closest?e.target.closest('[data-co-vat]'):null;
    if(!b) return;
    try{localStorage.setItem(KEY,b.getAttribute('data-co-vat')==='ex'?'ex':'inc');}catch(err){}
    apply();
  });
  var t,mo=new MutationObserver(function(){clearTimeout(t);t=setTimeout(apply,60);});
  function start(){apply();mo.observe(document.body,{childList:true,subtree:true});}
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',start); else start();
})();
